/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Faq_Q3Inputs */

const en_fc_home_faq_q3 = /** @type {(inputs: Fc_Home_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where can I try FilmCraft online?`)
};

/**
* | output |
* | --- |
* | "Where can I try FilmCraft online?" |
*
* @param {Fc_Home_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_faq_q3 = /** @type {((inputs?: Fc_Home_Faq_Q3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Faq_Q3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_faq_q3(inputs)
});
export { fc_home_faq_q3 as "fc.home.faq.q3" }